import {baseRequestService} from "../base.ts";

export const eventsEventIdUndraftPut = (eventId: string) => baseRequestService({
    url: `/events/${eventId}/undraft`,
    method: 'PUT'
})